export const heroImages = [
	{
		id: 0,
		url: "https://sandbox.fyatu.com/new/img/clients/svg/visa-gray.svg"
	},
	{
		id: 1,
		url: "https://sandbox.fyatu.com/new/img/clients/svg/pci-dss-compliant.svg"
	},
	{
		id: 2,
		url: "https://sandbox.fyatu.com/new/img/clients/svg/ssl-secure.svg"
	},
	{
		id: 3,
		url: "https://sandbox.fyatu.com/new/img/clients/svg/mcafee.svg"
	},
]

export const whyUseUs = [
	{
		id: 0,
		img: "https://sandbox.fyatu.com/assets/img/icons/no-offer.png",
		title: "Sécurité",
		desc: "Tout est conservé sous un cryptage de niveau militaire de bout en bout pour protéger vos fonds lors de l'achat en ligne, de la recharge ou de transfert d'argent à vos partenaires."
	},
	{
		id: 1,
		img: "https://sandbox.fyatu.com/assets/img/icons/no-offer2.png",
		title: "Rapidité",
		desc: "Conçu pour être une solution rapide et instantanée aux besoins les plus urgents, Fyatu fourni les services d'achat, de recharge et de transfert d'argent quasi instantanés pour les clients et les business."
	},
	{
		id: 2,
		img: "https://sandbox.fyatu.com/assets/img/icons/no-offer3.png",
		title: "Fiabilité",
		desc: "Nous savons à quel point l'argent est difficile à gagner, Fyatu agit en toute transparence, crédibilité et loyauté envers ses clients. Aucun centime du client ne peut se perdre dans le néant."
	},
]

export const advantages = [
	{
		id: 0,
		img: "https://sandbox.fyatu.com/assets/img/icons/credit-card2.png",
		title: "Cartes Prépayées Virtuelles",
		desc: "Créez des Cartes Prépayées VISA illimitées pour vous et vos clients. Effectuez des paiements en ligne sécurisés et rechargez vos cartes avec votre solde Fyatu."
	},
	{
		id: 1,
		img: "https://sandbox.fyatu.com/assets/img/icons/credit-card2.png",
		title: "Transfert d'argent International",
		desc: "Envoyez de l'argent vers les Comptes Mobile Money dans plus de 14 pays ou envoyez du Perfect Money, Payer, Bitcoin partout dans le monde à partir de votre solde Fyatu."
	},
	{
		id: 2,
		img: "https://sandbox.fyatu.com/assets/img/icons/recharge.png",
		title: "Recharge Mobile Universelle",
		desc: "Effectuez des recharges en ligne sans frais, envoyez du crédit d'appel dans plus de 140 pays du monde en utilisant le solde de votre compte Fyatu."
	},
	{
		id: 3,
		img: "https://sandbox.fyatu.com/assets/img/icons/gift.png",
		title: "Cartes Cadeaux Universelles",
		desc: "Achetez et partagez les cartes cadeaux à vos clients, proches et amis avec votre solde Fyatu compatibles avec plus de 6000 services & plateformes en lignes."
	},
]

export const countries = [
  {
		id: 7,
		code: "CD",
		name: "Congo-Kinshasa"
	},
	{
		id: 8,
		code: "CD",
		name: "Congo-Kinshasa"
	},
	{
		id: 9,
		code: "CD",
		name: "Congo-Kinshasa"
	},
	{
		id: 10,
		code: "CD",
		name: "Congo-Kinshasa"
	},
	{
		id: 11,
		code: "CD",
		name: "Congo-Kinshasa"
	},
	{
		id: 12,
		code: "CD",
		name: "Congo-Kinshasa"
	},
	{
		id: 13,
		code: "CD",
		name: "Plus 150+ autres pays"
	}
]

export const footerLinks = [
  {
    id: 0,
    text: "Carte Virtuelles"
  },
  {
    id: 1,
    text: "Transfert d'Argent"
  },
  {
    id: 2,
    text: "Recharge Mobile"
  },
  {
    id: 3,
    text: "Cartes Cadeaux"
  },
]